import { userConstants } from "../constants/login.constants";

 function signUp(state = {}, action) {
    switch (action.type) {
        case userConstants.SIGNUP_REQUEST:
            return {
                loading: true
            };
        case userConstants.SIGNUP_SUCCESS:
            return {
                items: action.signUp
            };
        case userConstants.SIGNUP_FAILURE:
            return {
                error: action.errorSignup
            };
        default:
            return state
    }
}
export default signUp;